<script>
import { onMount } from 'svelte';
import { navigate, Route, Router } from 'svelte-routing';
import Icon from 'svelte-awesome';
import { questionCircleO } from 'svelte-awesome/icons';
import ItemDetailView from './ItemDetailView.svelte';
import GroupListView from './GroupListView.svelte';
import Subscription from "./Subscription.svelte";
import Notes from './Notes.svelte';
import Sources from './Sources.svelte';
import PopupNewItemButtonModal from "../components/PopupNewItemButtonModal.svelte";
import PopupForNewUser from '../components/PopupForNewUser.svelte';
import PopupForItemManager from '../components/popups/ManageItem/index.svelte';
import PopupForFilterItems from '../components/popups/FilterItems/index.svelte';
import ItemContainer from "../components/ItemContainer.svelte";
import TagCommunitiesComponent from "../components/TagCommunitiesComponent/index.svelte";
import { userHomeMock } from '../mocks/Mocks.svelte';
import { USER_HOME_MOCK } from '../mocks/UserHomeMock';
import { getCookie } from '../helpers.svelte';

// subscribe, set, update methods on a store
import feedStore from '../stores/feed';
import url from '../stores/url';
import { setAuth, queryAllItems, queryGetItemsWithSources, clearAuth } from '../stores/helpers';
import { hashTheTag } from '../stores/entities';

let subscriptions = [];
let itemsFromFeeds = {};
let itemTagsMap = {}
let subscriptionItems = [];
let feedItems = [];
let feedToDisplay = [];
let activeFeed = 'myFeed';
const excludeSet = new Set();
let loaded = false;
let isNewUser = false;

// item manager modal
let itemManagerModalVisible = false;
let itemToManage = null;
let indexOfItemToManage = null;

// filter modal
let filterModalVisible = false;
let filteredItems = {};

$: pathname = $url.pathname;
$: roleValue = $feedStore.roleValue
// $: currentUserID = $feedStore.currentUserID

const showTips = () => {
    isNewUser = !isNewUser;
}

const showItemManager = () => {
    itemManagerModalVisible = !itemManagerModalVisible;
}
const showFilterItemsModal = () => {
    filterModalVisible = !filterModalVisible;
}

// mapReduce = (a -> b, (b,a) -> b, (b,a) -> b)
const mapReduce = (m,r) =>
  (acc,x) => r (acc, m (x))

// concatMap :: (a -> [b]) -> [a] -> [b]
const concatMap = f => xs =>
  xs.reduce (mapReduce (f, concat), [])

// concat :: ([a],[a]) -> [a]
const concat = (xs,ys) =>
  xs.concat (ys)

// id :: a -> a
const id = x =>
  x

// flatten :: [[a]] -> [a]
const flatten =
  concatMap (id)
  
// deepFlatten :: [[a]] -> [a]
const deepFlatten =
  concatMap (x =>
    Array.isArray (x) ? deepFlatten (x) : x)

// function addNewSubscription({ id, name, feeds, dayOfWeek }) {
//     subscriptions.push({ subscription: { id, name, feeds, dayOfWeek } });
// }

function mergeSortItems(itemList1, itemList2) {
    let result = [];
    let i = 0;
    let j = 0;
    while (i < itemList1.length && j < itemList2.length) {
        if (Date.parse(itemList1[i].pubDate) < Date.parse(itemList2[j].pubDate)) {
            result.push(itemList2[j])
            j++
        } else {
            result.push(itemList1[i])
            i++
        }
    }

    if (i < itemList1.length) {
        result = result.concat(itemList1.slice(i))
    }

    if (j < itemList2.length) {
        result = result.concat(itemList2.slice(j))
    }

    return result;
}

function sortSubscriptionItems() {
    const { indexes, itemsLength } = subscriptions.reduce((acc, subscription) => {
        acc.indexes.push(0);
        acc.itemsLength += subscription.items.length;
        return acc;
    }, {
        indexes: [],
        itemsLength: 0,
    });

    let result = [];
    let loopingIndex = 0;
    while (result.length < itemsLength) {
        // keep looping through subscriptions and getting chunks of items
        const sortedItems = getSortedItems(loopingIndex, indexes);
        result = result.concat(sortedItems);

        if (result.length === itemsLength) break;

        if (handleCurrentSubscriptionItemsNewerThanNextSubscriptionItems(loopingIndex, indexes)) {
            loopingIndex = loopingIndex;
        } else if (loopingIndex + 1 == subscriptions.length) {
            loopingIndex = 0
        } else {
            loopingIndex++
        }
    }

    ([result,] = result.reduce((acc, item) => {
        if (item.link || item.textBody) {
            const [items, itemLinkingLookup] = acc;
            const itemLink = item.link || hashTheTag(item.textBody)
            if (!(itemLink in itemLinkingLookup)) {
                itemLinkingLookup[itemLink] = item.subscriptionID ? [item.subscriptionID] : []
            } else {
                if (item.subscriptionID) {
                    itemLinkingLookup[itemLink].push(item.subscriptionID)
                }
                item['dupe'] = true;
            }
            item['linkIdentifier'] = itemLink;
            items.push(item);
        }
        return acc;
    }, [
        [],
        // new Set()
        {},
    ]));

    // ([result,] = result.reduce((acc, item) => {
    //     if (!acc[1].has(item.link)) {
    //         acc[1].add(item.link);
    //         acc[0].push(item);
    //     }
    //     return acc;
    // }, [
    //     [],
    //     new Set()
    // ]));

    return result;
}

function getSortedItems(loopingIndex, indexes) {
    const currentSubscription = subscriptions[loopingIndex];
    let currentSubscriptionItemIndex = indexes[loopingIndex];

    const items = currentSubscription.items;

    if (currentSubscriptionItemIndex + 1 > items.length) return [];

    const currentEditionID = items[currentSubscriptionItemIndex].editionID;
    const sortedItems = []
    while (items[currentSubscriptionItemIndex].editionID === currentEditionID) {
        sortedItems.push(items[currentSubscriptionItemIndex]);
        if (currentSubscriptionItemIndex + 1 >= items.length) break;
        currentSubscriptionItemIndex++
    }

    indexes[loopingIndex] = currentSubscriptionItemIndex;

    return sortedItems;   
}

const handleCurrentSubscriptionItemsNewerThanNextSubscriptionItems = (
    // items,
    loopingIndex,
    indexes,
    // subscriptions,
) => {
    // let sortedItems = [];
    const items = subscriptions[loopingIndex].items;
    const nextLoopingIndex = loopingIndex >= indexes.length ? 0 : loopingIndex + 1;
    const nextSubscription = subscriptions[nextLoopingIndex];
    const nextItem = nextSubscription && nextSubscription.items[indexes[nextLoopingIndex]];
    if (nextItem) {
        const currSubscriptionNextDate = Date.parse(
            items[indexes[loopingIndex]].pubDate
        );
        const nextSubscriptionNextDate = Date.parse(
            nextItem.pubDate
        );
        if (currSubscriptionNextDate > nextSubscriptionNextDate) {
            // TODO: if this function has no purpose, delete it.
            return false;
        }
    }

    return false;
}

const filterAwaySource = domain => {
    excludeSet.add(domain);
    let url = `/json/${activeFeed}`;

    if (excludeSet.size > 0) {
        url += '?'
    }

    excludeSet.forEach(excludedDomain => {
        url += `exclude=${excludedDomain}&`
    });

    if (url[url.length - 1] === '&') {
        url = url.slice(0, -1);
    }

    // make api call to /json/<usecase>?exclude=domain
    fetch(`${url}`)
    .then(data => {
        return data.json()
    })
    .then(response => {
        feedToDisplay = response.items
    })
}

function handleManageItemAction(item, index) {
    // show a modal
    itemManagerModalVisible = true;
    itemToManage = item;
    indexOfItemToManage = index;
}

function updateLocalItem({ updatedTagNames, newItem }) {
    if (!itemToManage?.editionID && newItem) {
        itemToManage = newItem
    }

    itemToManage.tags = updatedTagNames;
    feedToDisplay[indexOfItemToManage] = itemToManage;
}

function handleFilterAction(item) {
    // show a modal
    filterModalVisible = true;
    itemToManage = item;
}

function mockUserHome(emptyState=false) {
    let m;
    if (emptyState) {
        m = {};
    } else {
        // m = userHomeMock;
        m = USER_HOME_MOCK;
    }
    // console.log("make user-home api request")
    processApiResponse(m);
}

function getUserHome() {
    fetch(`/api/v1/user-home`)
    .then(data => {
        return data.json()
    })
    .then(response => {
        if (response.status === 401) {
            clearAuth();
            navigate('/login');
            return;
        }
        processApiResponse(response);
    });
}

/**
 * Item Types
 * S: subscription
 * F: feed
 * N: note
 */

function dedupeItems(feedItems) {
    // loop through feedItems, track index of each link and if a link shows up again, figure out if it needs to be replaced
    const urlLookup = {};
    const itemsDict = {};
    JSON.parse(JSON.stringify(feedItems)).forEach((item, idx) => {
        const itemLink = item.linkIdentifier || item.link || hashTheTag(item.textBody);

        if (itemLink) {
            if (itemLink in urlLookup) {
                feedItems[idx] = null;
                const { type, index } = urlLookup[itemLink];
                // if (type == 'S') return;
                if (type == 'F') {
                    feedItems[index] = item;
                }
            }
            urlLookup[itemLink] = {
                type: item.subscriptionID ? 'S' : 'F',
                id: item.id,
                index: idx,
            }
        }
        itemsDict[item.id] = item
    });

    return {
        items: feedItems.filter(item => item && !!!item.dupe),
        itemsDict,
    }
}

function processApiResponse(userHomeApiResponse) {
    ({
        subscriptions = [],
        itemsFromFeeds = {},
        itemTagsMap = {},
    } = userHomeApiResponse);

    feedItems = Object.values(itemsFromFeeds)
        .reduce((acc, itemsFromFeed) => (
            mergeSortItems(itemsFromFeed, acc)
        ), []);

    subscriptionItems = sortSubscriptionItems();
    feedItems = mergeSortItems(feedItems, subscriptionItems);

    const { items, itemsDict } = dedupeItems(feedItems);

    feedToDisplay = items;

    // const a1 = new Date();
    // console.log('a start', a1.getTime());
    feedStore.setFeed(subscriptions, itemTagsMap, itemsDict);
    // const a2 = new Date();
    // console.log('a end', a2.getTime());
    // console.log('a diff in seconds:', Math.abs(a1 - a2) / 1000);

    // loaded
    loaded = true;
}


// mockUserHome(false)

onMount(() => {
    if (getCookie('is_new') === 'yes') {
        const local_is_new = window.localStorage.getItem('is_new');
        if (!local_is_new || local_is_new !== 'no') {
            // show UI
            isNewUser = true;
            window.localStorage.setItem('is_new', 'no');
        }
    }

    const role = getCookie('role');
    const currentUserID = getCookie('userID');
    if (role) {
        // TODO: remove
        // const currentUserID = "9";
        setAuth({ role, currentUserID })
    }

    getUserHome();
    // mockUserHome();
});

const displayItems = (items, tag=null) => {
    let itemsToDisplay = items;
    if (tag) {
        itemsToDisplay.sort((a, b) => {
            const aHasTag = a.tags.includes(tag);
            const bHasTag = b.tags.includes(tag);
            if (aHasTag && !bHasTag) {
                return -1;
            } else if (!aHasTag && bHasTag) {
                return 1;
            }
            return 0;
        });
    }

    feedToDisplay = itemsToDisplay;
}

function goHomeFeed() {
    const items = queryAllItems();
    displayItems(items);
    navigate('/')
}

function changeFilteredSourceItems(add, sourceName) {
    // use map to create items list and call displayItems
    // filteredItems
    if (!add) {
        delete filteredItems[sourceName]
    } else {
        filteredItems[sourceName] = queryGetItemsWithSources([sourceName])
    }

    displayItems(Object.values(filteredItems).flat())
}

function addItemToFilter(add, sourceName, item) {
    if (!add && !(sourceName in filteredItems)) return;
    if (!add) {
        filteredItems[sourceName] = filteredItems[sourceName].filter(_item => _item.id !== item.id)
    } else {
        filteredItems[sourceName] = [...(filteredItems[sourceName] || []), item]
    }
    displayItems(Object.values(filteredItems).flat())
}

</script>
<Router>
    <main>
        {#if !loaded}
            <div style="display: flex;justify-content: center; margin-top:50%;">
                loading...
            </div>
        {:else}
            <div style="display: flex; justify-content:space-between;cursor:pointer;">
                <h3
                    id="site-title"
                    style="display: flex;align-items:center;"
                    class={pathname === '/' ? 'not-active' : ''}
                    on:click={goHomeFeed}
                >
                    evergreen
                </h3>

                <div style="display:flex;">
                    <h3
                        style="margin-right:10px;display: flex;align-items:center;cursor:pointer;"
                        class={pathname === '/groups' ? 'not-active' : ''}
                        on:click={() => navigate('/groups')}>
                        groups
                    </h3>
                    <h3
                        style="margin-right:10px;display: flex;align-items:center;cursor:pointer;"
                        class={pathname === '/sources' ? 'not-active' : ''}
                        on:click={() => navigate('/sources')}>
                        sources
                    </h3>
                    <h3
                        style="margin-right:10px;display: flex;align-items:center;cursor:pointer;"
                        class={pathname.startsWith('/notes') ? 'not-active' : ''}
                        on:click={() => navigate('/notes')}
                    >
                        notes
                    </h3>
                    <h3 on:click={() => showTips()}
                        style="display: flex;align-items:center;cursor:pointer;"
                    >
                        <Icon data={questionCircleO} scale={2} />
                    </h3>
                </div>
            </div>

            {#if isNewUser}
                <PopupForNewUser showTips={showTips} />
            {:else if itemManagerModalVisible}
                <PopupForItemManager 
                    showItemManager={showItemManager}
                    item={itemToManage}
                    activeFeed={activeFeed}
                    updateLocalItem={updateLocalItem}
                    subscriptions={subscriptions.map(s => s.subscription)}
                />
            {:else if filterModalVisible}
                <PopupForFilterItems
                    showFilterItemsModal={showFilterItemsModal}
                    item={itemToManage}
                    changeFilteredSourceItems={changeFilteredSourceItems}
                    addItemToFilter={addItemToFilter}
                    filteredItems={filteredItems}
                    subscriptions={subscriptions.map(s => s.subscription)}
                />
            {/if}
        {/if}

    {#if loaded}
        <Route path="">
            <PopupNewItemButtonModal subscriptions={subscriptions.map(s => s.subscription)} />
            {#if feedToDisplay}
                <!-- show tags if activeFeed is 'myFeed' -->

                <div style="display:flex;" class="feed-container">
                    {#if activeFeed === 'myFeed'}
                        <TagCommunitiesComponent
                            feedToDisplay={feedToDisplay}
                            displayItems={displayItems}
                            handleManageItemAction={handleManageItemAction}
                            handleFilterAction={handleFilterAction}
                        />
                    {/if}
                    <div style="width: 60%;" class="item-container-lg-screen">
                        {#each feedToDisplay as item, index (index)}
                            {#if !!!item.dupe}
                                <ItemContainer
                                    index={index}
                                    item={item}
                                    filterAwaySource={activeFeed !== 'myFeed' ? filterAwaySource : undefined}
                                    handleManageItemAction={handleManageItemAction}
                                    handleFilterAction={handleFilterAction}
                                />
                            {/if}
                        {/each}
                    </div>
                </div>
            {/if}
        </Route>
        <Route path="/s/:subscriptionID" let:params>
            <Subscription subscriptionID="{params.subscriptionID}" />
          </Route>
        <Route path="/i/:itemID" component="{ItemDetailView}" />
        <Route path="/groups" >
            <GroupListView subscriptions={subscriptions} />
        </Route>
        {#if roleValue && roleValue > 1}
            <Route path="/sources" component={Sources} />
        {/if}
        <Route path="/notes/*" component="{Notes}" />
    {/if}

    </main>
</Router>

<style>
    main {
        max-width: 80%;
        margin: auto;
    }
    h3.not-active {
        font-weight: 400;
        color: gray;
    }

    @media (max-width: 640px) {
        .item-container-lg-screen {
            display: none;
        }
        main {
            max-width: 100%;
        }
    }
</style>